import React, { useState } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import "../../../../../../../css/workspace.css";
import {
    Button,
    Tabs,
    Avatar,
    Card,
    Popover,
    Checkbox,
    Tooltip,
    Input,
    Upload,
    Table,
    Tag,
    Space,
    Select,
    Image,
    Radio,
  } from "antd";
  import {
    AppstoreOutlined,
    FileTextOutlined,
    LinkOutlined,
    InfoCircleOutlined,
    PlusCircleOutlined,
    FileAddOutlined,
    CloseCircleTwoTone,
    DeleteTwoTone,
    ExportOutlined,
    FullscreenExitOutlined,
    EditOutlined,
    DeleteOutlined,
    PlusOutlined,
    TagsOutlined,
    CheckCircleOutlined,
    PlayCircleOutlined,
    StopOutlined,
    GlobalOutlined,
    PauseCircleOutlined,
    FontSizeOutlined
  } from "@ant-design/icons";

import UploadDocuments from './uploadDocuments';
import ManageDocuments from './manageDocuments';

const UploadSpace = ({ expandedBox, setExpandedBox }) => {

  const { TabPane } = Tabs;
  const expandBox = (boxId) => {
    setExpandedBox(boxId);
  };
  const collapseBox = () => {
    setExpandedBox(null);
  };

  return (
    <div
      className={`flex-item-grid ${
        expandedBox === "box1" ? "expanded expanded-upload" : ""
      } ${expandedBox && expandedBox !== "box1" ? "hidden" : ""}`}
      id="box1"
    >
      <div className="fl-grid-block">
        <span className="block-name">Upload</span>
        <Tabs
          defaultActiveKey="1"
          type="card"
          tabBarExtraContent={
            expandedBox === "box1" ? (
              <FullscreenExitOutlined
                onClick={collapseBox}
                className="tab-full-icon"
              />
            ) : (
              <ExportOutlined
                onClick={() => expandBox("box1")}
                className="tab-full-icon"
              />
            )
          }
        >
          <TabPane tab="Upload Documents" key="1">
            <UploadDocuments />
          </TabPane>
          <TabPane tab="Manage Uploaded Documents" key="2">
            <ManageDocuments />
          </TabPane>
        </Tabs>
      </div>
    </div>
  )
}

export default UploadSpace;

